import { PhoneOutlined, UserOutlined } from "@ant-design/icons";
import { HiOutlineMail } from "react-icons/hi";
import { Button } from "antd";
import React from "react";
import { FaUserTag } from "react-icons/fa";
import { LiaUserTagSolid } from "react-icons/lia";

export const modalApplicantIntervenantInputs = ({
  setOpen,
  name,
  update = false,
  values = null,
}) => [
  {
    parentLabel:
      name === "applicant"
        ? "Informations demandeur"
        : "Informations responsable",
    children: [
      {
        placeholder: "Nom",
        addonBefore: <UserOutlined />,
        name: name === "applicant" ? "info.lastname" : "lastname",
        value: values?.lastname,
        type: "input",
        capitalize: true,
        required: true,
        col: 12,
      },
      {
        placeholder: "Prénom",
        addonBefore: <UserOutlined />,
        name: name === "applicant" ? "info.firstname" : "firstname",
        value: values?.firstname,
        capitalize: true,
        required: true,
        type: "input",
        col: 12,
      },
      {
        name: name === "applicant" ? "info.phone" : "phone",
        addonBefore: <PhoneOutlined />,
        placeholder: "Téléphone",
        type: "input",
        value: values?.phone,
        col: 12,
      },
      {
        name: name === "applicant" ? "info.role" : "role",
        addonBefore: <LiaUserTagSolid />,
        placeholder: "Fonction",
        type: "input",
        value: values?.role,
        col: 12,
      },
      {
        addonBefore: <HiOutlineMail />,
        name: "email",
        required: name === "applicant",
        placeholder: "E-mail",
        value: values?.email,
        type: "input",
        normalize: value => value && value.toLowerCase(),
        col: 24,
      },
      {
        name: "invitation",
        label: "Envoyer l'email d'invitation",
        required: true,
        visible: name === "applicant",
        value: true,
        type: "checkbox-bool",
        col: 24,
      },
    ],
  },
  {
    children: [
      {
        col: 20,
        type: "component",
        component: () => (
          <Button
            size={"large"}
            onClick={() => {
              setOpen(false);
            }}
          >
            Annuler
          </Button>
        ),
        align: "right",
      },
      {
        label: update ? "mettre à jour" : "Créer et insérer",
        name: "send",
        value: "send",
        type: "submit",
        col: 4,
        align: "right",
      },
    ],
  },
];
